/* template */
<template><div class="container" v-if="(show)"><div class="content"><mpx-image :src="(trainIconUrl)" class="train"></mpx-image><span class="text">登录12306 享官方直购</span></div><div class="action"><mpx-view @tap="toLoginPage" class="btn">立即登录</mpx-view><es-icon @click="close" custom-class="close" name="close-filled" size="15"></es-icon></div></div></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m50775d85"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m50775d85"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex50775d85%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex50775d85%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m50775d85"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index50775d85/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
